module.exports = __webpack_public_path__ + "static/media/wicketPykes.c6c62097.jpg";